import React from 'react';

import { Svg, Path, SvgProps } from 'react-native-svg';

import { colors } from '@/constants/colors';

const MiniBandIcon: React.FC<SvgProps> = (props) => {
  const {
    width = '100%',
    height = '100%',
    color = colors.white.primary,
    ...restProps
  } = props;

  return (
    <Svg
      enable-background={'new 0 0 467.36 178.68'}
      viewBox={'0 0 467.36 178.68'}
      width={width}
      height={height}
      {...restProps}
    >
      <Path
        fill={color}
        d={
          'M460.95,63.82s-14.88-30.99-43.42-57.36c-24.21-27.67-103.75,42.37-125.8,44.53s-127.04,9.19-171.71-20.9C75.35,0,55.89,.3,29.15,10.94,2.4,21.58,0,57.4,0,57.4c0,0,18.08,94.74,34.08,110.74s39.76,11.94,104.62,0c46.47-8.56,43.98-10.56,69.97-11.96,40.92-2.19,92.32-5.64,117.32-10.44,54.04-9.32,102.55-9.91,114.1-16.98,21.73-11.97,27.03-27.11,27.25-35.84,.53-21.2-6.37-29.11-6.37-29.11Zm-2.82,28.82c-2.57,11.36-9.48,28.59-49.47,31.98-40,3.39-64.72,8.57-104.6,14.34-40.35,5.84-91.21,2.34-118.11,7.8-26.6,5.39-83.71,17.18-110.15,18.54-26.44,1.36-40.02-8.12-41.26-30.58,0,0,.76-38.57,50.58-42.3,49.83-3.73,81.9,38.48,133.89,39.66,57.18,1.3,97.1-.72,137.47-16.27,44.57-17.17,33.04-53.14,82.18-50.43,17.25,1.18,21.23,19.48,19.47,27.26Z'
        }
      />
    </Svg>
  );
};

export default MiniBandIcon;
